module.exports = __webpack_public_path__ + "img/gift7-02-c1.c7d97701.png";